module.exports = __webpack_public_path__ + "static/img/Kotoni-Staggs.eb7fbe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kotoni-Staggs.jpg
// module id = 3ANi
// module chunks = 0